export default __webpack_public_path__ + "static/media/product-page-4.97685b0f.png";